/* eslint-disable camelcase */
/* eslint-disable no-unreachable */
/* eslint-disable no-useless-escape */
const { formatPaymentMethodsPayloadToString, convertPaymentMethodsPayloadLanguage } = require('../utils/utils');

const componentCodeBack = (formData) => {
  const paymentMethodsPayload = formatPaymentMethodsPayloadToString(formData);
  const paymentMethodsPayloadRaw = formatPaymentMethodsPayloadToString(formData, true);
  const userHasChangedPaymentMethods = !!(paymentMethodsPayloadRaw.excluded_payment_methods.length || paymentMethodsPayloadRaw.excluded_payment_types.length || (paymentMethodsPayloadRaw.installments !== 1));

  try {
    return [
      {
        code: `
        import { MercadoPagoConfig, Preference } from 'mercadopago';

        const client = new MercadoPagoConfig({ accessToken: 'YOUR_ACCESS_TOKEN' });

        const preference = new Preference(client);

        preference.create({
          body: {
            ${userHasChangedPaymentMethods && `payment_methods: ${paymentMethodsPayload}`},
            items: [
              {
                title: 'My product',
                quantity: 1,
                unit_price: 2000
              }
            ],
          }
        })
        .then(console.log)
        .catch(console.log);
        `,
        type: 'javascript',
        extension: 'js',
        value: 'node',
        name: 'Node.js',
      },
      {
        code: `
        <?php
          use MercadoPago\\Client\\Payment\\PreferenceClient;
          use MercadoPago\\MercadoPagoConfig;
        
        
          MercadoPagoConfig::setAccessToken("YOUR_ACCESS_TOKEN");
        
          $client = new PreferenceClient();
          $request_options = new MPRequestOptions();
          $request_options->setCustomHeaders(["X-Idempotency-Key: <SOME_UNIQUE_VALUE>"]);
        
          $preference = $client->create([
            "items"=> array(
              array(
                "title" => "My product",
                "quantity" => 1,
                "unit_price" => 2000
              )
            ),
            ${userHasChangedPaymentMethods && `"payment_methods" => ${convertPaymentMethodsPayloadLanguage(paymentMethodsPayloadRaw, 'php').replace(/\\n/g, '\n')}`}
          ]);
          echo implode($payment);
        ?>
        `,
        type: 'php',
        extension: 'php',
        value: 'php',
        name: 'PHP',
      },
      {
        code: `
        // SDK de Mercado Pago
        import com.mercadopago.MercadoPagoConfig;
        // Agrega credenciales
        MercadoPagoConfig.setAccessToken("PROD_ACCESS_TOKEN");

        PreferenceItemRequest itemRequest = PreferenceItemRequest.builder()
        .id("item-ID-1234")
        .title("Meu produto")
        .currencyId("BRL")
        .pictureUrl("https://www.mercadopago.com/org-img/MP3/home/logomp3.gif")
        .description("Descrição do Item")
        .categoryId("art")
        .quantity(1)
        .unitPrice(new BigDecimal("75.76"))
        .build();

        List<PreferenceItemRequest> items = new ArrayList<>();
        items.add(itemRequest);

        Payer payer = new Payer();
        payer.setName("João");
        payer.setSurname("Silva");
        payer.setEmail("user@email.com");
        Phone phone = new Phone();
        phone.setAreaCode("11");
        phone.setNumber("4444-4444");
        payer.setPhone(phone);
        Identification identification = new Identification();
        identification.setType("CPF");
        identification.setNumber("19119119100");
        payer.setIdentification(identification);
        Address address = new Address();
        address.setStreetName("Street");
        address.setStreetNumber(123);
        address.setZipCode("06233200");
        payer.setAddress(address);

        BackUrls backUrls = new BackUrls();
        backUrls.setSuccess("https://www.success.com");
        backUrls.setFailure("http://www.failure.com");
        backUrls.setPending("http://www.pending.com");

        ${convertPaymentMethodsPayloadLanguage(paymentMethodsPayloadRaw, 'java').replace(/\\n/g, '\n')}

        PreferenceRequest preferenceRequest = PreferenceRequest.builder()
                .items(items)
                .payer(payer)
                .backUrls(backUrls)
                .autoReturn("approved")
                .paymentMethods(paymentMethods)
                .notificationUrl("https://www.your-site.com/ipn")
                .statementDescriptor("MEUNEGOCIO")
                .externalReference("Reference_1234")
                .expires(true)
                .expirationDateFrom("2016-02-01T12:00:00.000-04:00")
                .expirationDateTo("2016-02-28T12:00:00.000-04:00")
                .build();
        `,
        type: 'java',
        extension: 'java',
        value: 'java',
        name: 'Java',
      },
      {
        code: `
        require 'mercadopago'
        sdk = Mercadopago::SDK.new('YOUR_ACCESS_TOKEN')

        preference_data = {
          items: [{
            id: "item-ID-1234",
            title: "Meu produto",
            currency_id: "BRL",
            picture_url: "https://www.mercadopago.com/org-img/MP3/home/logomp3.gif",
            description: "Descrição do Item",
            category_id: "art",
            quantity: 1,
            unit_price: 75.76
          }],
          payer: {
            name: "João",
            surname: "Silva",
            email: "user@email.com",
            phone: {
              area_code: "11",
              number: "4444-4444"
            },
            identification: {
              type: "CPF",
              number: "19119119100"
            },
            address: {
              street_name: "Street",
              street_number: 123,
              zip_code: "06233200"
            }
          },
          back_urls: {
            success: "https://www.success.com",
            failure: "http://www.failure.com",
            pending: "http://www.pending.com"
          },
          auto_return: "approved",
          ${userHasChangedPaymentMethods && `payment_methods: ${paymentMethodsPayload}`},
          notification_url: "https://www.your-site.com/ipn",
          statement_descriptor: "MEUNEGOCIO",
          external_reference: "Reference_1234",
          expires: true,
          expiration_date_from: "2016-02-01T12:00:00.000-04:00",
          expiration_date_to: "2016-02-28T12:00:00.000-04:00"
        }

        preference_response = sdk.preference.create(preference_data)
        preference = preference_response[:response]

        # Este valor substituirá a string "<%= @preference_id %>" no seu HTML
        @preference_id = preference['id']
        `,
        type: 'ruby',
        extension: 'rb',
        value: 'ruby',
        name: 'Ruby',
      },
      {
        code: `
        // Cria o objeto de request da preferência
        var request = new PreferenceRequest
        {
          Items = new List<PreferenceItemRequest>
          {
              new PreferenceItemRequest
              {
                  Id = "item-ID-1234",
                  Title = "Meu produto",
                  CurrencyId = "BRL",
                  PictureUrl = "https://www.mercadopago.com/org-img/MP3/home/logomp3.gif",
                  Description = "Descrição do Item",
                  CategoryId = "art",
                  Quantity = 1,
                  UnitPrice = 75.76m
              }
          },
          Payer = new PayerRequest
          {
              Name = "João",
              Surname = "Silva",
              Email = "user@email.com",
              Phone = new PhoneRequest
              {
                  AreaCode = "11",
                  Number = "4444-4444"
              },
              Identification = new IdentificationRequest
              {
                  Type = "CPF",
                  Number = "19119119100"
              },
              Address = new AddressRequest
              {
                  StreetName = "Street",
                  StreetNumber = 123,
                  ZipCode = "06233200"
              }
          },
          BackUrls = new BackUrlsRequest
          {
              Success = "https://www.success.com",
              Failure = "http://www.failure.com",
              Pending = "http://www.pending.com"
          },
          AutoReturn = "approved",
          PaymentMethods = new PaymentMethodsRequest
          ${convertPaymentMethodsPayloadLanguage(paymentMethodsPayloadRaw, 'c#'.replace(/\\n/g, '\n'))}
          NotificationUrl = "https://www.your-site.com/ipn",
          StatementDescriptor = "MEUNEGOCIO",
          ExternalReference = "Reference_1234",
          Expires = true,
          ExpirationDateFrom = DateTimeOffset.Parse("2016-02-01T12:00:00.000-04:00"),
          ExpirationDateTo = DateTimeOffset.Parse("2016-02-28T12:00:00.000-04:00")
        };

        // Cria a preferência usando o client
        var client = new PreferenceClient();
        Preference preference = await client.CreateAsync(request);
        `,
        type: 'csharp',
        extension: 'cs',
        value: 'csharp',
        name: 'C Sharp',
      },
      {
        code: `
        # Cria um item na preferência
        preference_data = {
          "items": [
            {
                "id": "item-ID-1234",
                "title": "Meu produto",
                "currency_id": "BRL",
                "picture_url": "https://www.mercadopago.com/org-img/MP3/home/logomp3.gif",
                "description": "Descrição do Item",
                "category_id": "art",
                "quantity": 1,
                "unit_price": 75.76
            }
        ],
        "payer": {
            "name": "João",
            "surname": "Silva",
            "email": "user@email.com",
            "phone": {
                "area_code": "11",
                "number": "4444-4444"
            },
            "identification": {
                "type": "CPF",
                "number": "19119119100"
            },
            "address": {
                "street_name": "Street",
                "street_number": 123,
                "zip_code": "06233200"
            }
        },
        "back_urls": {
            "success": "https://www.success.com",
            "failure": "http://www.failure.com",
            "pending": "http://www.pending.com"
        },
        "auto_return": "approved",
        ${userHasChangedPaymentMethods && `"payment_methods": ${convertPaymentMethodsPayloadLanguage(paymentMethodsPayload, 'python').replace(/\\n/g, '\n')}`},
        "notification_url": "https://www.your-site.com/ipn",
        "statement_descriptor": "MEUNEGOCIO",
        "external_reference": "Reference_1234",
        "expires": True,
        "expiration_date_from": "2016-02-01T12:00:00.000-04:00",
        "expiration_date_to": "2016-02-28T12:00:00.000-04:00"
        }

        preference_response = sdk.preference().create(preference_data)
        preference = preference_response["response"]
        `,
        type: 'python',
        extension: 'py',
        value: 'python',
        name: 'Python',
      },
    ];
  } catch (error) {
    console.log('error', error);
    return [
      {
        code: '',
        type: 'html',
        name: 'html',
      },
    ];
  }
};

module.exports = componentCodeBack;
